import { BwObjectPromise, BwFilters } from "src/app/service/global.service";
import { FiltreController } from "./filtre-controller";
import { database } from "src/app/acces_manager";
import { Backend } from "../backend";

/**
 * Controller used for search filters managment
 * 
 * Used for filter compromise reports and attestations
 */

export class BwFiltreController extends FiltreController {
  /**
     * 
     * @param objectAc 
     * @param value
     * @returns string[]
     * 
     * Return all version OS existings in objectAc
     * 
     * With param value choose the good "distinctxxxxx" which is a stringify map so must parse to an Object 
     * 
     * before interface this last as an usable object
     */
  public getVersionsOS(objectAc: BwObjectPromise | undefined, value: string) {
    let versions: string[] = []
    if (objectAc) {
      switch (value.toLowerCase()) {
        case "android":
          {
            let aVersion = JSON.parse(objectAc.distinctVersionsAndroid)
            aVersion.forEach((map: Map<string, string>) => {
              if (Object(map).platformVersion) {
                versions.push(Object(map).platformVersion)
              }
            })
            break
          }
        case "ios":
          {
            let iosVersion = JSON.parse(objectAc.distinctVersionsIos)
            iosVersion.forEach((map: Map<string, string>) => {
              if (Object(map).platformVersion) {
                versions.push(Object(map).platformVersion)
              }
            })
            break
          }
        default: {
          versions = []
        }
      }
    }
    return versions
  }

  /**
  * 
  * @param objectAc 
  * @returns string[] (List)
  * 
  * objectAc.distinctAppNamesAndVersions is a stringify map so must parse to an Object 
  * 
  * before interface this last as an usable object
  *  
  */
  getAllAppVersion(objectAc: BwObjectPromise | undefined, appname: string) {
    let l: any = []
    if (objectAc) {
      let appsVersions = JSON.parse(objectAc.distinctAppNamesAndVersions)
      appsVersions = appsVersions.filter((map: Map<string, string[]>) => Object(map).appName.toLowerCase() == appname.toLowerCase())
      appsVersions.forEach((map: Map<string, string[]>) => l = Object(map).appVersion);
    }
    return l
  }

  /**
   * 
   * @param objectAc 
   * @returns string[] (List)
   * 
   * objectAc.distinctAppNamesAndVersions is a stringify map so must parse to an Object 
   * 
   * before interface this last as an usable object
   *  
   */
  getAllAppNames(objetAC: BwObjectPromise | undefined): string[] {
    let appNames: any[] = []
    if (objetAC) {
      let listeAppandV = JSON.parse(objetAC.distinctAppNamesAndVersions)
      listeAppandV.forEach((app: Map<string, string>) => {
        if (!appNames.includes(Object(app).appName)) {
          appNames.push(Object(app).appName)
        }
      });
    }
    return appNames
  }

  /**
   * 
   * @param objectAc 
   * @returns string[] (List)
   * 
   * objectAc.distinctModelName is a stringify map so must parse to an Object 
   * 
   * before interface this last as an usable object
   *  
   */
  getAllDevices(objectAc: BwObjectPromise | undefined): string[] {
    let models: any[] = []
    if (objectAc) {
      let parseModels = JSON.parse(objectAc.distinctModelNames)
      parseModels.forEach((modelMap: Map<string, string>) => {
        models.push(Object(modelMap).model)
      });
    }
    return models
  }
  /**
   * @param objectAc 
   * 
   * @returns all Black & white versions an ObjectPromise
   * 
   */

  getAllBWVersions(objectAc: BwObjectPromise | undefined) {
    let vBW: any = []
    if (objectAc) {
      let lVBW = JSON.parse(objectAc.distinctBwVersions)
      lVBW.forEach((map: Map<string, string>) => { vBW.push(Object(map).bwSdkVersion) });
    }
    return vBW
  }

  /**
   * 
   * @param objectAc 
   * @returns string[]
   * 
   * Return all OS existings in objectAc
   */
  getAllOS(objectAc: BwObjectPromise | undefined): string[] {
    let os: any[] = []
    if (objectAc) {
      if (objectAc.distinctVersionsAndroid) {
        os.push('android')
      }
      if (objectAc.distinctVersionsIos) {
        os.push('ios')
      }
      if (objectAc.distinctVersionsIpados) {
        os.push('ipados')
      }
    }
    return os
  }

  /**
   * 
   * @param objetAC 
   * @param name 
   * @param type 
   * @returns ObjectPromise
   * 
   * Doing a search request with a filter AppName name as per the type given (compromise or attestation)
   */
  async filtreAppFromAll(objetAC: BwObjectPromise | undefined, name: string, type: string) {
    let objectAPP = {}
    Object(objectAPP)[name] = this.getAllAppVersion(objetAC, name)
    let filters: BwFilters = {}
    if (type == "compro") {
      filters.pageSize = 25
      filters.appNamesAndVersions = objectAPP
      database.setdata('compromiseFilters', filters)
      return await Backend.COMPROMISE_REPORTS.search(filters)
    } else if (type == "attes") {
      filters.pageSize = 50;
      filters.appNamesAndVersions = objectAPP;
      database.setdata('attestationsFilters', filters);
      return await Backend.ATTESTATIONS.search(filters);
    } else {
      return undefined;
    }

  }

  /**
   * 
   * @param filterActive 
   * @param newfilter 
   * 
   * Change filterActive's attributes by newfilter's attributes
   */
    patchMainFilters(filterActive: BwFilters, newfilter: BwFilters | undefined) {
      filterActive.appNamesAndVersions = newfilter?.appNamesAndVersions
      filterActive.platformNames = newfilter?.platformNames
      filterActive.androidPlatformVersions = newfilter?.androidPlatformVersions
      filterActive.iosPlatformVersions = newfilter?.iosPlatformVersions
      filterActive.models = newfilter?.models
      filterActive.bwSdkVersions = newfilter?.bwSdkVersions
      filterActive.bwAppId = newfilter?.bwAppId
      filterActive.deviceId = newfilter?.deviceId
      filterActive.id = newfilter?.id
      filterActive.metadata = newfilter?.metadata
      filterActive.page = newfilter?.page
      return filterActive
    }
}


